import { render, staticRenderFns } from "./TransactionPreview.vue?vue&type=template&id=5307da72&"
import script from "./TransactionPreview.vue?vue&type=script&lang=js&"
export * from "./TransactionPreview.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports